export const SENIOR_MARKETING_SALARY_HOUR_MULTIPLIER = 102;
export const GAMIFICATION_ECONOMY_MESSAGE = ':relativeTime of work saved with TESS and Pareto Ads';
